<template>
    <div class="customer">
        <div class="bg">
            <img src="../../assets/image/customer/customer.png" alt=""/>
        </div>
        <div class="customer-list">
            <div class="list-nav" @click="toPage(item)" v-for="(item, index) in customers" :key="index">
                <img :src="'/' + item + '.png'" :alt="item"/>
                <span>{{ $t(`case.${item}.name`) }}</span>
                <div>
                    {{ $t(`case.${item}.details`) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        toPage(name) {
            this.$router.push('/' + name);
        }
    },
    data() {
        return {
            customers: [
                'haoen',
                'jinghua',
                'lixun',
                'hangsheng',
                'zechen',
                'hengtianweiyan',
                'shennandianlu',
                'sanjiang',
                'nanruijibao',
                'huayang',
                'zhuoao',
                'changcheng',
                'huarong',
                'kangyuan',
                'weixin',
                'hainengda',
            ]
        }
    }
};
</script>

<style scoped>
.customer {
    padding-top: 80px;
}

.bg > img {
    width: 100%;
}

.customer-list {
    width: 1200px;
    margin: 70px auto 60px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.list-nav {
    width: 25%;
    margin-bottom: 50px;
    margin-left: 0 !important;
}

.list-nav:hover {
    cursor: pointer;
}

.customer-list .list-nav > img {
    display: block;
    width: 280px;
    height: 200px;
    margin-left: 0 !important;
}

.list-nav > span {
    margin-top: 15px;
    font-size: 18px;
    font-weight: bold;
    color: #121212;
    line-height: 54px;
}

.list-nav > div {
    margin-left: 0 !important;
    width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    color: #a6a6a6;
    line-height: 17px;
}
</style>
